import axios from 'axios';
import { EnvironmentConfig } from '../constants.js';
export default {
    name: 'ACRService',
    data() {
        return {
            baseApiUrl: '',
            APIKey: ''
        }
    },
    created: function () {
        //URL and endpoint constants
        this.baseApiUrl = EnvironmentConfig._baseURL;
        this.APIKey = EnvironmentConfig._APIURL;
    },
    methods: {
        BankClientMapping() {
            const bankClientMapUrl = this.baseApiUrl + '/api/TaxTransformation/GetBanks';
            const params = {
                'UserId': localStorage.getItem('userId'),
                'FirstName': localStorage.getItem('firstName'),
                'LastName': localStorage.getItem('lastName'),
                'AppName': "ACR",
                'UserName': localStorage.getItem('userName')
            };
            return axios({
                method: 'post',
                url: bankClientMapUrl,
                headers: {
                    'APIKey': this.APIKey,
                    'Authorization': 'Bearer ' + localStorage.getItem('JWTToken')
                },
                data: params
            }).then(response => {
                if (response) {
                    return response;
                }
            })
                .catch(function () {
                });
        },
        RemoveMapping() {
            const deleteMapUrl = this.baseApiUrl + '/admin/deleteBankClientDetails';
            const params = { "BankName": localStorage.getItem("bankName"), "ClientName": localStorage.getItem("clientName"), "UserId": localStorage.getItem('userId') }

            return axios({
                method: 'post',
                url: deleteMapUrl,
                headers: {
                    'APIKey': this.APIKey,
                    'Authorization': 'Bearer ' + localStorage.getItem('JWTToken')
                },
                data: params
            }).then(response => {
                if (response) {
                    return response;
                }
            }).catch(error => {
                return error;
            });
        },
        ImportUploadedData(formdata) {
            const uploadFileUrl = this.baseApiUrl + '/api/TaxTransformation/Import';
            return axios.post(uploadFileUrl,
                formdata, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'APIKey': this.APIKey,
                    'Authorization': 'Bearer ' + localStorage.getItem('JWTToken')
                }
            }
            ).then(function (response) {
                if (response) {
                    return response;
                }
            })
                .catch(function () {
                });
        },
        AddBankClientDetails(username, bankname, clientname, bankid, clientid) {

            const addBankClientUrl = this.baseApiUrl + '/Admin/AddBankClientDetails';
            console.log(addBankClientUrl);
            console.log(username + bankname + clientname + bankid + clientid)
            if (bankid < 0) {
                bankid = 0;
            }
            if (clientid < 0) {
                clientid = 0;
            }
            const params = { "username": username, "bankname": bankname, "ClientName": clientname, "BankId": bankid, "ClientId": clientid }
            return axios({
                method: 'post',
                url: addBankClientUrl,
                headers: {
                    'APIKey': this.APIKey,
                    'Authorization': 'Bearer ' + localStorage.getItem('JWTToken')
                },
                data: params
            }).then(response => {
                if (response) {
                    return response;
                }
            })
                .catch(function () {
                });
        },
        BankDesAndAccNo() {
            const bankDesAccountnoUrl = this.baseApiUrl + '/api/TaxTransformation/GetMasterDetails';
            const params = ["acr.BankDescriptions", "acr.ToTvsAccountNo"];
            return axios({
                method: 'post',
                url: bankDesAccountnoUrl,
                headers: {
                    'APIKey': this.APIKey,
                    'Authorization': 'Bearer ' + localStorage.getItem('JWTToken')
                },
                data: params
            }).then(response => {
                if (response)
                    return response
            }).catch(error => {
                return error;
            })
        },
        AddBuisnessLogic(BankName, ClientName, BankDescription, AccountNo, UserId) {
            const addDescAccNoUrl = this.baseApiUrl + '/api/TaxTransformation/AccountMap';
            const params = { "BankName": BankName, "ClientName": ClientName, "Description": BankDescription, "AccountNo": AccountNo, "UserId": UserId }
            return axios({
                method: 'post',
                url: addDescAccNoUrl,
                headers: {
                    'APIKey': this.APIKey,
                    'Authorization': 'Bearer ' + localStorage.getItem('JWTToken')
                },
                data: params
            }).then(response => {
                if (response) {
                    return response;
                }
            })
                .catch(function () {
                });
        },
        RemoveDescriptionAccountMapping() {
            const deleteMapUrl = this.baseApiUrl + '/api/TaxTransformation/DeleteAccountMap';
            const params = {
                "BusinessRuleID": localStorage.getItem("buisnessruleID"),
                UserDetails: {
                    "UserId": localStorage.getItem("userId"),
                    "FirstName": localStorage.getItem("firstName"),
                    "LastName": localStorage.getItem("lastName"),
                    "UserName": localStorage.getItem("userName")
                }
            }

            return axios({
                method: 'post',
                url: deleteMapUrl,
                headers: {
                    'APIKey': this.APIKey,
                    'Authorization': 'Bearer ' + localStorage.getItem('JWTToken')
                },
                data: params
            }).then(response => {
                if (response) {
                    return response;
                }
            }).catch(error => {
                return error;
            });
        },

        GetBuisnessLogic() {
            const getDescAccNoUrl = this.baseApiUrl + '/api/TaxTransformation/GetAccountMap';
            return axios({
                method: 'post',
                url: getDescAccNoUrl,
                headers: {
                    'APIKey': this.APIKey,
                    'Authorization': 'Bearer ' + localStorage.getItem('JWTToken')
                }
            }).then(response => {
                if (response) {
                    return response;
                }
            })
                .catch(function () {
                });
        },
        DownloadRule() {
            const param = {
                'UserName': localStorage.getItem('userName')
            };
            axios({
                url: this.baseApiUrl + '/api/TaxTransformation/DownloadRules',
                method: 'POST',
                headers: {
                    'APIKey': this.APIKey,
                    'Authorization': 'Bearer ' + localStorage.getItem('JWTToken')
                },
                data: param,
                responseType: 'blob',
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'BankClientRules.xlsx');
                document.body.appendChild(link);
                link.click();
            })
                .catch(function () {
                });
        },
        UploadTemplateDetail(formdata) {
            const uploadFileUrl = this.baseApiUrl + '/api/TaxTransformation/UploadBusinessRules';
            console.log(formdata);
            return axios.post(uploadFileUrl,
                formdata, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'APIKey': this.APIKey,
                    'Authorization': 'Bearer ' + localStorage.getItem('JWTToken')
                }
            }
            ).then(function (response) {
                if (response) {
                    console.log(response);
                    return response;
                }
            }).catch(function () {
            });
        }
    }
}